import { Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";

import * as s from "./combobox.module.css";

interface ComboBoxPros {
  label?: string;
  value: string;
  placeholder?: string;
  items: Array<any>;
  handleInput: (item: any) => void;
  displayName: string;
}

export const ComboBox: React.FC<ComboBoxPros> = ({
  value,
  items,
  placeholder,
  handleInput,
  displayName,
  label
}) => {
  const [selectedValue, setSelectedValue] = useState<string>("");

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  return (
    <>
      {label && <label className={`${s.comboLabel}`}>{label}</label>}
      <div className={s.comboContainer}>
        <Autocomplete
          sx={{
            display: "inline-block",
            width: "100%",
            borderBottom: "2px solid #7a3fc7",
            "& input": {
              border: 0,
              background: "none",
              padding: "5px 0px",
              width: "100%",
            },
          }}
          disablePortal
          getOptionLabel={(option) => option[displayName]}
          options={items}
          onChange={(event: any, newValue: string | null) => {
            if (newValue) handleInput(newValue);
          }}
          renderInput={(params) => (
            <div ref={params.InputProps.ref} className="fs-18px">
              <input
                className="autocomplete-input"
                value={selectedValue}
                placeholder={placeholder}
                {...params.inputProps}
                type="text"
              />
            </div>
          )}
        />
      </div>
    </>
  );
};
